import React from 'react';
import './Sections.scss';
import Statistics from '../Statistics/Statistics';

function Section6() {
  return (
    <section className="sections sections-section6">
      <h2 className="sections-title">Creative Financing</h2>
      <p className="sections-copy sections--margin">
        When it comes to financing the down payment, a mortgage assistance program may just be one
        piece of the puzzle. “Home buyers are finding they need to become more creative,” Lautz
        says, “than the traditional bread and butter of ‘I will save for an X period of time, and
        then I will buy my first home’.” Putting together the rest of the puzzle may require pulling
        from different sources. For instance, a first time buyer might put a downpayment by drawing
        on a combination of savings, a 401k loan, stock sales, and a gift from a relative. 1% of
        recent buyers even used cryptocurrency to help finance their mortgage.
      </p>
      <Statistics />
      <p className="sections-copy">
        No matter how you finance your down payment, first-time buyers will still find a challenging
        housing market awaits them. But they can better equip themselves for success by educating
        themselves and working with experts. A good mortgage broker can find competitive rates or
        underutilized assistance programs, and the expertise of a REALTOR®, who follows a code of
        ethics, can identify overlooked areas, and help you understand the bidding landscape. The
        good news is that though it might take a bit longer for first time buyers to find a house,
        it is still possible. “I think that there's a lot of potential first time home buyers and
        renters who are really discouraged right now,” Lautz says. “And I just hope that they hold
        onto that dream of home ownership because, if you work with those experts, they'll try and
        help you get there—perhaps sooner than you imagined you could.”
      </p>
    </section>
  );
}

export default Section6;
